export const spacing = {
  'spacing-0': '0px',
  'spacing-1': '4px',
  'spacing-2': '8px',
  'spacing-3': '16px',
  'spacing-4': '24px',
  'spacing-5': '32px',
  'spacing-6': '40px',
  'spacing-7': '48px',
  'spacing-8': '56px',
  'spacing-9': '64px',
  'spacing-10': '72px',
  'spacing-11': '80px',
};
